export const EDIT_DATES_SET_EDITOR_CONFIG = 'EDIT_DATES_SET_EDITOR_CONFIG';
export const EDIT_DATES_SET_EDITOR_SEGMENTS = 'EDIT_DATES_SET_EDITOR_SEGMENTS';
export const EDIT_DATES_SET_SEGMENT_SELECTED = 'EDIT_DATES_SET_SEGMENT_SELECTED';
export const EDIT_DATES_RESET_EDITOR_STATE = 'EDIT_DATES_RESET_EDITOR_STATE';
